import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const submitApplication = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/check/application`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};
